export default class DnPageAnchor {
  init() {
    const path = location.href.split('?')[0];
    const $targets = $('.mdDnPageAnchor, .dn-link-page-top');
    $targets.each(function() {
      const $target   = $(this),
            withQuery = $target.data('page-anchor-query');

      $target.find('a').attr('href', withQuery ? location.href : path);
    });
  }
}



// WEBPACK FOOTER //
// ./src/js/manager/old-modules/modules/DnPageAnchor.js